<template>
    <div class="block3">
        <div class="page-box-layout">
            <ul>
                <li>
                    <div class="text">
                        <div class="name">极速上传</div>
                        <p>告别冗余信息，流程化繁为简</p>
                    </div>
                    <div class="value-1">
                        <div class="num">
                            <IOdometer :value="value1"></IOdometer>
                            秒
                        </div>
                        <p>极速上传</p>
                    </div>
                    <div class="value-2">
                        <div class="num">
                            <IOdometer :value="value1"></IOdometer>
                            倍
                        </div>
                        <p>效率提升</p>
                    </div>
                </li>
                <li>
                    <div class="text">
                        <div class="name">分发全球</div>
                        <p>一键上传，轻松上架全球平台</p>
                    </div>
                    <div class="value-1">
                        <div class="num">
                            <IOdometer :value="value2"></IOdometer>
                            +
                        </div>
                        <p>国家/地区</p>
                    </div>
                    <div class="value-2">
                        <div class="num">
                            <IOdometer :value="value2"></IOdometer>
                            +
                        </div>
                        <p>音乐平台</p>
                    </div>
                </li>
                <li>
                    <div class="text">
                        <div class="name">保障权益</div>
                        <p>无霸王条款，艺术家权益100%保障</p>
                    </div>
                    <div class="value-1">
                        <div class="num">
                            <IOdometer :value="value3"></IOdometer>
                            %
                        </div>
                        <p>艺术家版权归属</p>
                    </div>
                    <div class="value-2">
                        <div class="num">
                            <IOdometer :value="value3"></IOdometer>
                            %
                        </div>
                        <p>艺术家版税收益</p>
                    </div>
                </li>
            </ul>
            <div class="taihe">
                <div class="lb">
                    <img data-aos="fade" src="@/assets/img/index/taihe.png" />
                    <h1 data-aos="fade">太合音乐集团，强大支持</h1>
                    <p data-aos="fade">
                        共享太合音乐集团和秀动的优势资源
                        <br />
                        全力支持艺术家的生涯发展
                    </p>
                </div>
                <div class="rb">
                    <div data-aos="fade" data-aos-delay="100" class="item">
                        <span class="icon-block-3-1"></span>
                        <div class="text">
                            <p>
                                Production
                                <br />
                                support
                            </p>
                            <b>制作支持</b>
                        </div>
                    </div>
                    <div data-aos="fade" data-aos-delay="200" class="item">
                        <span class="icon-block-3-2"></span>
                        <div class="text">
                            <p>
                                Publicity release
                                <br />
                                support
                            </p>
                            <b>宣发支持</b>
                        </div>
                    </div>
                    <div data-aos="fade" data-aos-delay="300" class="item">
                        <span class="icon-block-3-3"></span>
                        <div class="text">
                            <p>
                                The performance
                                <br />
                                support
                            </p>
                            <b>演出支持</b>
                        </div>
                    </div>
                    <div data-aos="fade" data-aos-delay="400" class="item">
                        <span class="icon-block-3-4"></span>
                        <div class="text">
                            <p>
                                Legal
                                <br />
                                support
                            </p>
                            <b>法务支持</b>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import IOdometer from 'vue-odometer';
import 'odometer/themes/odometer-theme-default.css';
export default {
    components: {
        IOdometer
    },
    data() {
        return {
            value1: 0,
            value2: 0,
            value3: 0,
            isOdometer: true
        };
    },
    mounted() {
        const self = this;
        window.addEventListener(
            'touchmove',
            function(e) {
                const y = e.touches[0].pageY;
                if (y > 2600 && self.isOdometer) self.setNum();
            },
            true
        );
        window.addEventListener(
            'scroll',
            function() {
                if (document.documentElement.scrollTop > 2600 && self.isOdometer) self.setNum();
            },
            true
        );
    },
    methods: {
        setNum() {
            this.value1 = 30;
            this.value2 = 200;
            this.value3 = 100;
            this.isOdometer = false;
        }
    }
};
</script>
<style lang="scss" scoped>
.block3 {
    ul {
        padding: 80px 0 70px;
        li {
            border-bottom: 1px solid #ccc;
            padding: 70px 0;
            display: flex;
            align-items: flex-end;
            justify-content: space-between;
            p {
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                line-height: 20px;
                margin-top: 14px;
            }
            .text {
                flex: 1;
                .name {
                    font-size: 24px;
                    font-weight: 600;
                    color: #000000;
                    line-height: 33px;
                }
            }
            .value-1,
            .value-2 {
                flex: 1;
            }
            .num {
                font-size: 48px;
                font-weight: bold;
                color: #000000;
                line-height: 60px;
            }
        }
    }
    .taihe {
        margin-bottom: 150px;
        .lb {
            img {
                width: 96px;
            }
            h1 {
                font-size: 36px;
                font-weight: 600;
                color: #000000;
                line-height: 50px;
                margin-top: 14px;
            }
            p {
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                line-height: 24px;
                margin-top: 35px;
            }
        }
        .rb {
            display: flex;
            margin-top: 41px;
            .item {
                width: 290px;
                height: 354px;
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                position: relative;
                .text {
                    position: absolute;
                    bottom: 40px;
                    left: 40px;
                    right: 40px;
                    p {
                        font-size: 16px;
                        font-weight: bold;
                        color: #ffffff;
                        line-height: 19px;
                        margin-bottom: 13px;
                    }
                    b {
                        font-size: 18px;
                        font-weight: 600;
                        color: #ffffff;
                        line-height: 25px;
                    }
                }
                .icon-block-3-1,
                .icon-block-3-2,
                .icon-block-3-3,
                .icon-block-3-4 {
                    background-size: cover;
                    background-position: center;
                    background-repeat: no-repeat;
                    position: absolute;
                    top: 40px;
                    left: 38px;
                }
                .icon-block-3-1 {
                    width: 45px;
                    height: 36px;
                    background-image: url('~@/assets/img/index/icon-block-3-1.png');
                }
                .icon-block-3-2 {
                    width: 35px;
                    height: 41px;
                    background-image: url('~@/assets/img/index/icon-block-3-2.png');
                }
                .icon-block-3-3 {
                    width: 42px;
                    height: 42px;
                    background-image: url('~@/assets/img/index/icon-block-3-3.png');
                }
                .icon-block-3-4 {
                    width: 38px;
                    height: 37px;
                    background-image: url('~@/assets/img/index/icon-block-3-4.png');
                }
                &:nth-child(1) {
                    background-image: url('~@/assets/img/index/block3-item-1.png');
                }
                &:nth-child(2) {
                    background-image: url('~@/assets/img/index/block3-item-2.png');
                }
                &:nth-child(3) {
                    background-image: url('~@/assets/img/index/block3-item-3.png');
                }
                &:nth-child(4) {
                    background-image: url('~@/assets/img/index/block3-item-4.png');
                }
            }
        }
    }
}
.odometer-theme-default {
    top: -4px;
}
</style>
